/**
 * Main Application Component
 * 
 * Uses the new route configuration for dynamic routing with lazy loading.
 * This significantly reduces bundle size through code splitting.
 */

import { HashRouter as Router } from 'react-router-dom';
import { AuthProvider, SidebarProvider, LanguageProvider } from '@/contexts';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { AppRoutes } from '@/routes';

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <SidebarProvider>
            <Router>
              <AppRoutes />
            </Router>
          </SidebarProvider>
        </AuthProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
